module.exports = __webpack_public_path__ + "static/media/gln.4788483a.gif";